import { type FC } from 'react';
import { Popconfirm } from 'antd';
import { Button, Space } from '@g2u/ui-kit';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';

import { type WithOptionalDataTest } from 'types';
import { PopconfirmDescription } from 'components';
import { BookingStore } from 'store';

type Props = {
  active: boolean;
  onNext: () => void;
  onBack: () => void;
  isLoading?: boolean;
  hasSlot?: boolean;
} & WithOptionalDataTest;

export const Actions: FC<Props> = observer((props) => {
  const { active, onNext, onBack, isLoading, hasSlot } = props;
  const navigate = useNavigate();
  const { resetBookingProgress } = BookingStore;

  const handleLeaveBooking = () => {
    navigate('/dashboard');
    resetBookingProgress();
  };

  return (
    <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small} justify={Space.Justify.End}>
      <Popconfirm
        title="Alert"
        onConfirm={onBack}
        description={<PopconfirmDescription hasSlot={hasSlot} />}
        okText="Yes"
      >
        <div>
          <Button.$ dataTestId="page-back-btn" onClick={() => null} disabled={isLoading}>
            &lt; Back
          </Button.$>
        </div>
      </Popconfirm>

      <Popconfirm
        title="Alert"
        onConfirm={() => {
          handleLeaveBooking();
        }}
        description={<PopconfirmDescription hasSlot={hasSlot} />}
        okText="Yes"
      >
        <div>
          <Button.$ dataTestId="page-cancel-btn" danger onClick={() => null} disabled={isLoading}>
            Cancel this booking
          </Button.$>
        </div>
      </Popconfirm>
      <Button.$
        type={Button.Type.Primary}
        dataTestId="page-next-btn"
        disabled={!active}
        onClick={onNext}
        loading={isLoading}
      >
        Confirm booking and continue &gt;
      </Button.$>
    </Space.$>
  );
});
